<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="CustomerOrder"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/CustomerOrder/CustomerOrderDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:item.notion_id="{ item }">
        <v-icon
                v-if="item.notion_id != null"
                color="primary"
                size="20"
                @click="onNotion(item)"
            >
              mdi-alpha-n-box-outline
            </v-icon>
      </template>
      <template v-slot:item.product_uid="{ item }">
        <span v-if="!!item.product_uid && storeAggregate.rootData">
          {{storeAggregate.rootData[item.product_uid].name}}
        </span>
      </template>
      <template v-slot:item.productorder="{ item }">
          {{item.product_orders_uid}}
      </template>
      <template v-slot:item.customer_uid="{ item }">
        <span v-if="!!item.customer_uid && storeAggregate.rootData">
          {{storeAggregate.rootData[item.customer_uid].name}}
        </span>
      </template>
      <template v-slot:item.location__name="{ item }">
        <span v-if="!!item.location_uid && storeAggregate.rootData">
          {{ storeAggregate.rootData[item.location_uid].name }}
        </span>
      </template>
      <template v-slot:item.product_orders_uid="{ item }">
        <span v-if="!!item.product_orders_uid && storeAggregate.rootData">
          <v-chip v-for="product_order_uid of item.product_orders_uid" outlined>{{ storeAggregate.rootData[product_order_uid].article_number }}</v-chip>
        </span>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CustomerOrderDetail from "@/components/CoreComponent/CustomerOrder/CustomerOrderDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "CustomerOrderTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'CustomerOrderTable'},
    dtoDetailQuery: {default: 'CustomerOrderDetailQueryDTO'},
    detailStoreName: {default: 'CustomerOrderDetail'},
    dtoValidateCommand: {type: [String], default: 'CustomerOrderValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'CustomerOrderListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'CustomerOrderActionCommandDTO'},
    // dtoSaveCommand: {type: [String], default: 'SimpleSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    CustomerOrderDetail,
    BaseFieldCheck,
  },

  methods: {
    onNotion(item) {
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'Edit', value: 'edit', sortable: false, filterable: true, divider: true, width: 10},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Notion', value: 'notion_id', sortable: true, filterable: true, divider: true, width: 10},
      {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true},
      {text: 'Alias', value: 'alias', sortable: true, filterable: true, divider: true},
      {text: 'Status', value: 'status', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Batch size', value: 'lot_size', sortable: true, filterable: true, divider: true, width: 100},
      // {text: 'product', value: 'product_uid', sortable: true, filterable: true, divider: true},
      // {text: 'product orders', value: 'productorder', sortable: true, filterable: true, divider: true},
      {text: 'Customer', value: 'customer_uid', sortable: true, filterable: true, divider: true},
      {text: 'Location', value: 'location__name', sortable: true, filterable: true, divider: true},
      {text: 'Product', value: 'product_uid', sortable: true, filterable: true, divider: true},
      {text: 'ProductOrder', value: 'product_orders_uid', sortable: true, filterable: true, divider: true},
      // {text: 'smd', value: 'smd', sortable: true, filterable: true, divider: true},
      // {text: 'tht', value: 'tht', sortable: true, filterable: true, divider: true},
      // {text: 'extra', value: 'extra', sortable: true, filterable: true, divider: true},
      {text: 'mat_vk', value: 'mat_vk', sortable: true, filterable: true, divider: true},
      {text: 'mat_ek', value: 'mat_ek', sortable: true, filterable: true, divider: true},
      {text: 'lp_vk', value: 'lp_vk', sortable: true, filterable: true, divider: true},
      {text: 'lp_ek', value: 'lp_ek', sortable: true, filterable: true, divider: true},
      {text: 'Edited by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'Edited on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'Created by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'Created on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'Saved', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 10},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      // this.storeTable.dtoSaveCommand = this.dtoSaveCommand
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>